import { Route, Routes } from "react-router-dom"
import List from "./views/List"
import { UpdateCashFlow } from "./views/UpdateCashFlow"

const CashFlowsRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/:id" element={<UpdateCashFlow />} />
    </Routes>
  )
}

export default CashFlowsRouter 